import { useEffect } from 'react'
import { initializeMetaPixel } from '@/lib/meta-pixel'
import { initializeGoogleCampaignTracking } from '@/lib/google-tag'

type RaspadinhaPublicPixelsProps = {
  fbPixel?: string
  gPixel?: string
}

/**
 * Carrega Meta Pixel e Google (GTM ou GA4) da raspadinha pública.
 * Reusa os carregadores da landing: o identificador é validado antes de tocar no DOM
 * e nunca entra como texto dentro de um `<script>`.
 * `g_pixel` da raspadinha pode ser contêiner GTM (GTM-…) ou medição GA4 (G-…).
 */
export function RaspadinhaPublicPixels({ fbPixel, gPixel }: RaspadinhaPublicPixelsProps) {
  useEffect(() => {
    initializeMetaPixel(fbPixel)
  }, [fbPixel])

  useEffect(() => {
    const normalized = (gPixel ?? '').trim().toUpperCase()
    if (!normalized) return

    initializeGoogleCampaignTracking({
      googleTagManagerContainerId: normalized.startsWith('GTM-') ? normalized : null,
      measurementId: normalized.startsWith('G-') ? normalized : null,
    })
  }, [gPixel])

  return null
}
